<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>ANAK</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Anak</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.nama_anak.$error}">
            <label> Nama Anak </label>
            <j-input
              v-model="$v.data_master.nama_anak.$model"
              placeholder="Nama Anak"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
            <label> Status </label>
            <j-input
              v-model="$v.data_master.status.$model"
              placeholder="Status"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenjang.$error}">
            <label> Jenjang </label>
            <j-input
              v-model="$v.data_master.jenjang.$model"
              placeholder="Jenjang"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nisn.$error}">
            <label> NISN </label>
            <j-input
              v-model="$v.data_master.nisn.$model"
              placeholder="NISN"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
            <label> Jenis Kelamin </label>
            <b-form-radio-group
              v-model="$v.data_master.jenis_kelamin.$model"
              :options="list_jenis_kelamin"
              :stacked="true"
              :disabled="false"
              class="jFormGroup"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
            <label> Tempat Lahir </label>
            <j-input
              v-model="$v.data_master.tempat_lahir.$model"
              placeholder="Tempat Lahir"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
            <label> Tanggal Lahir </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_lahir.$model"
              placeholder="Tanggal Lahir"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun_masuk.$error}">
            <label> Tahun Masuk </label>
            <j-input
              v-model="$v.data_master.tahun_masuk.$model"
              type="number"
              placeholder="Tahun Masuk"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Anak</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.nama_anak.$error}">
            <label> Nama Anak </label>
            <j-input
              v-model="$v.data_master.nama_anak.$model"
              :disabled="readOnly"
              placeholder="Nama Anak"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
            <label> Status </label>
            <j-input
              v-model="$v.data_master.status.$model"
              :disabled="readOnly"
              placeholder="Status"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenjang.$error}">
            <label> Jenjang </label>
            <j-input
              v-model="$v.data_master.jenjang.$model"
              :disabled="readOnly"
              placeholder="Jenjang"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nisn.$error}">
            <label> NISN </label>
            <j-input
              v-model="$v.data_master.nisn.$model"
              :disabled="readOnly"
              placeholder="NISN"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
            <label> Jenis Kelamin </label>
            <b-form-radio-group
              v-model="$v.data_master.jenis_kelamin.$model"
              :options="list_jenis_kelamin"
              :stacked="true"
              :disabled="readOnly"
              class="jFormGroup"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
            <label> Tempat Lahir </label>
            <j-input
              v-model="$v.data_master.tempat_lahir.$model"
              :disabled="readOnly"
              placeholder="Tempat Lahir"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
            <label> Tanggal Lahir </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_lahir.$model"
              :disabled="readOnly"
              placeholder="Tanggal Lahir"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun_masuk.$error}">
            <label> Tahun Masuk </label>
            <j-input
              v-model="$v.data_master.tahun_masuk.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Tahun Masuk"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jAnak',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['nama_anak', 'status', 'jenjang', 'nisn', 'jenis_kelamin', 'tempat_lahir', 'tanggal_lahir', 'tahun_masuk'],
      options: {
        headings: {
          nama_anak: 'NAMA',
          status: 'STATUS',
          jenjang: 'JENJANG PENDIDIKAN',
          nisn: 'NISN',
          jenis_kelamin: 'JK',
          tempat_lahir: 'TEMPAT LAHIR',
          tanggal_lahir: 'TANGGAL LAHIR',
          tahun_masuk: 'TAHUN MASUK',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['nama_anak', 'status', 'jenjang', 'nisn', 'jenis_kelamin', 'tempat_lahir', 'tanggal_lahir', 'tahun_masuk'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListAnak(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        status: '',
        jenjang: '',
        nisn: '',
        nama_anak: '',
        jenis_kelamin: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        tahun_masuk: null,
      },
      list_jenis_kelamin: [
        {
          value: 'L',
          text: 'Laki-Laki',
        },
        {
          value: 'P',
          text: 'Perempuan',
        },
      ],
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createAnak', 'updateAnak', 'deleteAnak']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        status: '',
        jenjang: '',
        nisn: '',
        nama_anak: '',
        jenis_kelamin: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        tahun_masuk: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        status: '',
        jenjang: '',
        nisn: '',
        nama_anak: '',
        jenis_kelamin: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        tahun_masuk: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        status: param.row.status,
        jenjang: param.row.jenjang,
        nisn: param.row.nisn,
        nama_anak: param.row.nama_anak,
        jenis_kelamin: param.row.jenis_kelamin,
        tempat_lahir: param.row.tempat_lahir,
        tanggal_lahir: param.row.tanggal_lahir,
        tahun_masuk: param.row.tahun_masuk,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createAnak(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updateAnak(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteAnak(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        status: { required },
        jenjang: { required },
        nisn: { required },
        nama_anak: { required },
        jenis_kelamin: { required },
        tempat_lahir: { required },
        tanggal_lahir: { required },
        tahun_masuk: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jAnak.vue